export default __webpack_public_path__ + "static/media/right-vector-login.a033b8d7.png";